interface FireworksIconProps {
    size?: number;
    className?: string;
}

const Fireworks = ({ size = 20, className = '' }: FireworksIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 638 315"
        width={size}
        height={size}
        fill="none"
        role="img"
        className={className}
    >
        <title>Fireworks</title>
        <path
            d="M318.563 221.755C300.863 221.755 284.979 211.247 278.206 194.978L196.549 0H244.342L318.842 178.361L393.273 0H441.066L358.92 195.048C352.112 211.247 336.263 221.755 318.563 221.755Z"
            fill="#6720FF"
        />
        <path
            d="M425.111 314.933C407.481 314.933 391.667 304.494 384.824 288.366C377.947 272.097 381.507 253.524 393.936 240.921L542.657 90.2803L561.229 134.094L425.076 271.748L619.147 270.666L637.72 314.479L425.146 315.003L425.076 314.933H425.111Z"
            fill="#6720FF"
        />
        <path
            d="M0 314.408L18.5727 270.595L212.643 271.677L76.525 133.988L95.0977 90.1748L243.819 240.816C256.247 253.384 259.843 272.026 252.93 288.26C246.088 304.424 230.203 314.827 212.643 314.827L0.0698221 314.339L0 314.408Z"
            fill="#6720FF"
        />
    </svg>
);

export default Fireworks;
